module.exports = __webpack_public_path__ + "97378fc45a8f58535c1c824bf616ecd8.svg";